import React from 'react';
import './AppBarMargin.css';

const AppBarMargin = ({ children }) => (
  <div className="AppBarMargin">
    {children}
  </div>
);

export default AppBarMargin;



// WEBPACK FOOTER //
// ./src/components/AppBarMargin.js